// src/lib/automation/eventTypes.js
// ─────────────────────────────────────────────────────────────────────────────
//  Typed event constants for the trigger engine.
//  Every cross-feature automation begins with one of these events.
// ─────────────────────────────────────────────────────────────────────────────

export const EVENTS = {
  // Discipleship
  ATTENDANCE_MARKED:       'ATTENDANCE_MARKED',
  DISCIPLE_MISSED_SESSIONS:'DISCIPLE_MISSED_SESSIONS',

  // People / Evangelism
  GOSPEL_STAGE_ADVANCED:   'GOSPEL_STAGE_ADVANCED',
  CONTACT_ADDED:           'CONTACT_ADDED',

  // Content
  SERMON_SAVED:            'SERMON_SAVED',
  JOURNAL_WRITTEN:         'JOURNAL_WRITTEN',

  // Prayer
  PRAYER_CHECKIN:          'PRAYER_CHECKIN',

  // Bible
  BIBLE_READING_ADVANCED:  'BIBLE_READING_ADVANCED',
  VERSE_HIGHLIGHTED:       'VERSE_HIGHLIGHTED',
  BIBLE_STUDY_COMPLETED:   'BIBLE_STUDY_COMPLETED',

  // Finances
  EXPENSE_RECORDED:        'EXPENSE_RECORDED',
  TITHE_RECORDED:          'TITHE_RECORDED',
};
